import { FC, useEffect } from 'react'
import { Form, json, replace, useActionData } from 'react-router-dom'

// COMPONENTS
import Button from '@components/atoms/button'
import TextField from '@components/atoms/textfield'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { createAction } from '@utils/actions'
import { isFailedResponse } from '@apis'
import { isEmail, isNonEmptyString } from '@utils/type-checkers'
import { useProfileEmailContext } from '..'
import { useInput } from '@hooks/inputs'


const Component: FC<{}> = () => {
    const data = useActionData()
    const { setToast } = useProfileEmailContext()
    const emailProps = useInput()[1]

    useEffect(() => {
        console.log(data)
        if (data != null) setToast({ type: 'error', text: isNonEmptyString(data) ? data : 'An unexpected Error occured' });
    }, [setToast, data])

    return (
        <Form className="flex flex-col" style={{ gap: 'inherit' }} method="POST">
            <h4>Add E-mail Address</h4>
            <TextField {...emailProps} type="email" name="email" placeholder="E-mail Address" autoComplete="email" required />
            <Button type="submit" theme="primary">Continue</Button>
        </Form>
    )
}

const action = createAction(async ({ request }) => {
    try {
        const data = await request.formData()
        const user = window.Clerk?.user
        const email = data.get('email')
        if (!isEmail(email) || !user) throw new Error(`${email} is formatted incorrectly`)

        const resource = await user.createEmailAddress({ email })
        return replace(`/account/profile/email/${resource.id}/verify`)
    } catch (error) {
        console.error(error)
        if (isFailedResponse(error) || error instanceof Error) return json(error.message);
        else return json('An unexpected Error occured')
    }
})

const AddEmailRoute: RouteObject = {
    index: true,
    Component,
    action,
}

export { AddEmailRoute } 
